import { useDispatch } from "react-redux";
import { createTheme } from "@material-ui/core/styles";

import "static/index.scss";

import { useBreakpoints } from "util/BreakpointProvider";
import lightTheme from "util/theme/lightTheme";
import darkTheme from "util/theme/restaurantPageDarkTheme";

const useTheme = () => {
  const dispatch = useDispatch();
  const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
  // const prefersDark = window.matchMedia("(prefers-color-scheme: light)")
  //   .matches;
  const ourTheme = prefersDark ? darkTheme : lightTheme;
  // const ourTheme = lightTheme;
  const bp = useBreakpoints();
  dispatch({ type: prefersDark ? "SET_THEME_DARK" : "SET_THEME_LIGHT" });

  return createTheme({
    light: lightTheme,
    dark: darkTheme,
    overrides: {
      MuiSvgIcon: {
        root: {
          fontSize: "1.5rem",
        },
        fontSizeSmall: {
          fontSize: "1.1rem",
        },
      },
      MuiButton: {
        contained: {
          boxShadow: "none",
        },
      },
      ...ourTheme?.overrides,
      MuiCssBaseline: {
        "@global": {
          a: {
            ...ourTheme?.typography?.a,
          },
          "input:-webkit-autofill": {
            boxShadow: "none!important",
            "-webkit-text-fill-color": `${ourTheme.palette.text.disabled}!important`,
          },
          "*::-webkit-scrollbar": {
            width: 5,
          },
          "*::-webkit-scrollbar-track": {
            background: "transparent",
          },

          "*::-webkit-scrollbar-thumb": {
            backgroundColor: ourTheme.palette.text.disabled,
            // borderRadius: 10,
            border: "1px solid transparent",
          },
          "*": {
            scrollbarWidth: "thin",
            scrollbarColor: `${ourTheme.palette.text.disabled} transparent`,
          },
        },
      },
    },
    typography: {
      fontFamily: ["DM Sans", "sans-serif"].join(","),
      h1: {
        color: ourTheme.palette.text.primary,
        fontSize: "2rem",
        lineHeight: 1.25,
        fontWeight: prefersDark ? 400 : 500,
      },
      h2: {
        color: ourTheme.palette.text.primary,
        fontWeight: prefersDark ? 400 : 500,
        fontSize: "1.2rem",
        lineHeight: "1rem",
        marginBottom: 24,
      },
      h3: {
        color: ourTheme.palette.text.primary,
        fontWeight: prefersDark ? 400 : 500,
        fontSize: "1.2rem",
        lineHeight: "1rem",
        marginBottom: 24,
      },
      h4: {
        color: ourTheme.palette.text.primary,
        fontWeight: prefersDark ? 400 : 500,
        fontSize: "1.1rem",
        lineHeight: "0.95rem",
        marginBottom: 24,
      },
      h5: {
        color: ourTheme.palette.text.primary,
        fontWeight: prefersDark ? 400 : 500,
        fontSize: "1rem",
        lineHeight: "0.875rem",
        marginBottom: 24,
      },
      h6: {
        color: ourTheme.palette.text.primary,
        fontWeight: prefersDark ? 400 : 500,
        fontSize: "0.875rem",
        lineHeight: "0.875rem",
      },
      body1: {
        color: ourTheme.palette.text.primary,
        fontSize: "0.875rem",
        lineHeight: "0.875rem",
        fontWeight: prefersDark ? 300 : 400,
      },
      body2: {
        color: ourTheme.palette.text.secondary,
        fontSize: "0.875rem",
        lineHeight: "0.875rem",
        fontWeight: prefersDark ? 300 : 400,
      },
      button: {
        fontSize: "0.875rem",
        ...ourTheme?.typography?.button,
      },
      fontWeightLight: prefersDark ? 100 : 300,
      fontWeightRegular: prefersDark ? 300 : 400,
      fontWeightMedium: prefersDark ? 400 : 500,
      fontWeightBold: prefersDark ? 600 : 700,
    },
    palette: ourTheme.palette,
    spacing: 4,
    bp,
    prefersDark,
  });
};
export { lightTheme };
export default useTheme;
